<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
	<div class="row">
		<div class="col-sm-12" style="display: inline-flex;">
			<div id="myMenuPanel" class="card">
				<div class="col-md-12 mb-2" [ngStyle]="{'height.px': videoHeight + labelHeight}">
					<label *ngIf="joinStatus.isJoined"
						[ngStyle]="{'color': '#ffffff','background-color': '#000000','height.px': labelHeight,'width':'100%'}">
						{{userName}}
						<fa-icon *ngIf="isMute" [icon]="['fas', 'microphone-slash']" class="float-end"></fa-icon>
						<fa-icon *ngIf="!isMute" [icon]="['fas', 'microphone']" class="float-end"></fa-icon>
					</label>
					<div [ngStyle]="{'height.px': videoHeight,'width': videoWidth}" id="agora_local"></div>
				</div>
				<ng-container *ngIf="videoClient">
					<ng-container *ngFor="let callId of remoteCalls;let i = index;">
						<div *ngIf="showDiv(callId.user.uid)" class="col-md-12 mb-2"
							[ngStyle]="{'cursor': 'pointer','height.px': videoHeight + labelHeight}" id="remoteDiv{{i}}"
							(click)="highlightStream(i)">
							<label
								[ngStyle]="{'color': '#ffffff','background-color': '#000000','height.px': labelHeight,'width':'100%'}">
								{{callId.uname}}
								<fa-icon *ngIf="!remoteCalls[i].user.audioTrack" [icon]="['fas', 'microphone-slash']"
									class="float-end"></fa-icon>
								<fa-icon *ngIf="remoteCalls[i].user.audioTrack" [icon]="['fas', 'microphone']"
									class="float-end"></fa-icon>
							</label>
							<div [ngStyle]="{'height.px': videoHeight,'width': videoWidth}" id="{{callId.user.uid}}">
							</div>
						</div>
					</ng-container>
				</ng-container>
			</div>
			<div id="myDiagramPanel" class="card">
				<div class="row">
					<div class="col text-center">
						<label class="me-3">
							Candidate Name:
							<strong>
								{{followUpDetails?.case_id?.candidate?.f_name}}
								{{followUpDetails?.case_id?.candidate?.l_name}}
							</strong>
						</label>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 mt-1 mb-1 text-center">
						<button class="btn btn-sm btn-info float-start" (click)="toggleNav()">
							<fa-icon *ngIf="!isPanelOpen" [icon]="['fas', 'arrow-right']"></fa-icon>
							<fa-icon *ngIf="isPanelOpen" [icon]="['fas', 'arrow-left']"></fa-icon>
						</button>
						<button type="button" class="btn btn-sm btn-primary me-1"
							(click)="openBackgroundModal()">Background</button>
						<button *ngIf="!joinStatus.isJoined" class="btn btn-sm btn-primary me-1" id="btnJoin"
							(click)="initJoinCall()" [disabled]="!userName">
							<fa-icon *ngIf="!userName" [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
							<span *ngIf="userName">Join</span>
						</button>
						<button *ngIf="joinStatus.isJoined" class="btn btn-sm btn-primary me-1" id="btnLeave"
							(click)="leave()" [disabled]="!userName">Leave</button>
						<button [ngClass]="isMute?'btn btn-sm btn-danger me-1':'btn btn-sm btn-success me-1'"
							id="btnMuteAudio" (click)="toggleMute()" [disabled]="!joinStatus.isJoined"
							matTooltip="{{isMute?'Unmute audio':'Mute audio'}}">
							<fa-icon *ngIf="isMute" [icon]="['fas', 'microphone-slash']"></fa-icon>
							<fa-icon *ngIf="!isMute" [icon]="['fas', 'microphone']"></fa-icon>
						</button>
						<button class="btn btn-sm btn-primary me-1" id="btnMuteVideo" (click)="toggleMuteVideo()"
							[disabled]="!joinStatus.isJoined" matTooltip="{{isVideoMute?'Unmute video':'Mute video'}}">
							<fa-icon *ngIf="!isVideoMute" [icon]="['fas', 'video']"></fa-icon>
							<fa-icon *ngIf="isVideoMute" [icon]="['fas', 'video-slash']"></fa-icon>
						</button>
						<button *ngIf="joinStatus.isJoined" class="btn btn-sm btn-primary me-1" id="btnShare"
							(click)="shareScreen()">Share Screen</button>
						<!-- <button *ngIf="joinStatus.isJoined" class="btn btn-sm btn-primary me-1" id="btnMuteCand"
							(click)="toggleCandidateMute()">
							@if (togglingCandMute) {
							<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
							}
							<span *ngIf="isMuteCandidate">Unmute</span>
							<span *ngIf="!isMuteCandidate">Mute</span>
							Candidate
						</button> -->
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 pe-2 ps-2">
						<div class="row">
							<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
								<label id="mainVideoLabel" *ngIf="currentVideo"
									style="color: #ffffff;background-color: #000000;width: 100%;">
									{{currentVideo.uname}}
									<fa-icon *ngIf="!currentVideo.user.audioTrack" [icon]="['fas', 'microphone-slash']"
										class="ms-1"></fa-icon>
									<fa-icon *ngIf="currentVideo.user.audioTrack" [icon]="['fas', 'microphone']"
										class="ms-1"></fa-icon>
									<button type="button" class="btn btn-xs btn-primary float-end"
										style="margin-left: 40px;" matTooltip="Minimize" (click)="minimizeMain()">
										<fa-icon [icon]="['fas', 'minus']"></fa-icon>
									</button>
								</label>
								<div id="{{currentVideo.user.uid}}" style="width: 100%;" *ngIf="currentVideo">
								</div>
								<h3 class="text-center" *ngIf="!currentVideo && remoteUsers.length">Candidate is online.
									Click on candidate's video to maximize.</h3>
							</div>
						</div>
						<div id="micCameraTest" *ngIf="!joinStatus.isJoined">
							<div class="row">
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pb-1 card">
									<div class="row">
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
											<label>Camera</label>
											<select class="form-select" id="camSelect" [(ngModel)]="selectedCameraId"
												(change)="changeMicOrCamera()">
												<option *ngFor="let item of videoDevices;let i = index;"
													value="{{item.deviceId}}">{{item.label == "" ?
													"Camera-"+(i+1):item.label}}</option>
											</select>
										</div>
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
											<div id="test_stream" style="width: 50%;height: 90px;margin-left: 25%;">
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
											<label>Microphone</label>
											<select class="form-select" id="micSelect"
												[(ngModel)]="selectedMicrophoneId" (change)="changeMicOrCamera()">
												<option *ngFor="let item of audioDevices;let i = index;"
													value="{{item.deviceId}}">{{item.label == "" ?
													"Mic-"+(i+1):item.label}}</option>
											</select>
										</div>
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1 text-center">
											<fa-icon [icon]="['fas', 'microphone']" size="2x"></fa-icon>
											<span *ngFor="let numb of numbers;" class="pid"
												[ngStyle]="numberOfPidsToColor>=numb.num?{'background-color':numb.color} : {'background-color': '#e6e7e8'}"></span>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1 text-center">
											<button class="btn btn-md btn-primary" (click)="testSpeaker()">Test
												Speaker</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
<button *ngIf="joinStatus.isJoined" style="z-index: 1000;" (click)="openForm()" type="button"
	class="btn btn-md btn-circle open-button btn-primary" id="videoChatButton">
	<fa-icon [icon]="['fas', 'comment']"></fa-icon>
</button>
<div id="myForm" class="chat-popup">
	<h3 style="background-color: #f34235;color: white;padding: 5px;" class="mt-0 mb-0">
		<small class="text-white">Chat with candidate</small>
		<fa-icon (click)="closeForm()" style="cursor: pointer;color: white !important;" [icon]="['fas', 'times']"
			class="float-end"></fa-icon>
	</h3>
	<form (ngSubmit)="sendMsg('',msg)" (keydown)="keyDownFunction($event)" class="form-container">
		<div class="chatBoxScroll">
			<div *ngFor="let msg of messages;let i = index;">
				<div class="col-sm-12 pl0 mt-1">
					<label
						[ngClass]="{'float-end chat-sender' : msg.from=='me', 'float-start chat-receiver' : msg.from!='me'}"
						class="control-label">
						<small class="timeStyle">{{msg.from}}:</small>
						@if (!msg.imageUrl) {
						<a *ngIf="validURL(msg.text)" href="{{msg.text}}" target="_blank">
							{{msg.text}}
						</a>
						<ng-container *ngIf="!validURL(msg.text)">
							{{msg.text}}
						</ng-container>
						}@else {
						<a href="{{msg.imageUrl}}" target="_blank">
							<fa-icon [icon]="['fas', 'file']" size="2x"></fa-icon>
							<p style="overflow-x: clip;">{{clipText(msg.text,20)}}</p>
						</a>
						}
						<br>
						<!-- <small class="timeStyle">{{msg.msgTime.seconds * 1000 | date:'dd-MM-yyyy h:mm a'}}</small> -->
					</label>
				</div>
			</div>
		</div>
		<textarea placeholder="Type message.." [(ngModel)]="msg" name="msgText"></textarea>
		<button type="submit" [disabled]="!msg" class="btn">Send</button>
		<!-- <fa-icon (click)="openFileMang()" matTooltip="File Upload" style="cursor: pointer;"
			[icon]="['fas', 'paperclip']" size="2x" class="ms-1"></fa-icon> -->
	</form>
</div>
<div class="modal fade" id="chatFileModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>File Upload</strong></h4>
				<fa-icon *ngIf="fileUploaderLoader" [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="caseFilesUpload($event)">
					<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
						<div style="text-align: center;">
							<label>*Drop files here</label><br>
							<label>OR</label><br>
							<button type="button" class="btn btn-primary btn-sm" (click)="openFileSelector()">Browse
								Files</button>
						</div>
					</ng-template>
				</ngx-file-drop>
			</div>
			<div class="modal-footer">
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="backgroundModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>Set Background</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div *ngFor="let c of bgColors" class="col-sm-4 text-center mb-2">
						<div class="bg-item" [ngStyle]="{'background-color':c}"
							(click)="setBackgroundProperty(c,'color')"></div>
					</div>
					<div *ngFor="let im of bgImages" class="col-sm-4 text-center mb-2">
						<div class="bg-item" (click)="setBackgroundProperty(im,'img')">
							<img src="{{im}}" class="bg-img" />
						</div>
					</div>
					<div class="col-sm-4 text-center mb-2">
						<div class="bg-item" matTooltip="Blur" (click)="setBackgroundProperty('','blur')">
							<img src="../../../assets/img/bg-blur.jpg" class="bg-img" />
						</div>
					</div>
					<div class="col-sm-4 text-center mb-2">
						<div class="bg-item text-center" style="padding-top: 30px;" matTooltip="Original"
							(click)="setBackgroundProperty('','')">
							Original
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-info" data-bs-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>